<template>
  <v-list class="pt-0">
    <!-- <v-subheader class="v-list-item"> -->
    <v-list-item>
      <v-list-item-title>
        <span
          class="text-uppercase"
          v-text="item.text"
        />
      </v-list-item-title>
    </v-list-item>

    <template v-for="(child, i) in item.children">
      <v-divider
        v-if="child.divider"
        :key="i + '_divider'"
      />
      <nav-item
        v-else
        :key="`item-${i}`"
        :icon="child.icon"
        :to="child.to"
        :text="child.text"
      />
    </template>
  </v-list>
</template>

<script>

import NavItem from '@/components/NavItem'

export default {
  components: { NavItem },
  inheritAttrs: false,
  props: {
    item: {
      type: Object,
      default: () => ({
        text: '',
        group: '',
        children: []
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.v-list-item {
  .v-list-item__title {
    font-size: 1rem;
    line-height: 1.1rem;
  }
  &:not(.v-list-item--active):not(.v-list-item--disabled) {
    opacity: 0.7;
    color: white;
    .v-icon {
      color: white;
    }
    &:hover {
      opacity: 1;
    }
  }
}
</style>
